import { gql } from "@apollo/client";

export const FETCH_TAGS = gql`
  query FETCH_TAGS {
    taggingTags {
      id
      value
      category {
        id
        name
      }
    }
  }
`;

export const FETCH_TAG_CATEGORIES = gql`
  query FETCH_TAG_CATEGORIES {
    taggingCategories {
      id
      name
      description
      tags {
        id
        value
      }
    }
  }
`;

export const CREATE_TAG = gql`
  mutation CREATE_TAG($categoryId: ID!, $value: String!) {
    taggingCreateTag(categoryId: $categoryId, value: $value) {
      tag {
        id
        value
        category {
          id
          name
          tags {
            id
            value
          }
        }
      }
    }
  }
`;

export const UPDATE_TAG = gql`
  mutation UPDATE_TAG($id: ID!, $value: String!) {
    taggingUpdateTag(id: $id, value: $value) {
      tag {
        id
        value
      }
    }
  }
`;

export const DELETE_TAG = gql`
  mutation DELETE_TAG($id: ID!) {
    taggingDeleteTag(id: $id) {
      id
      category {
        id
        name
        tags {
          id
          value
        }
      }
    }
  }
`;

export const CLEAR_CATEGORY_TAGS = gql`
  mutation CLEAR_CATEGORY_TAGS($categoryId: ID!) {
    taggingClearCategoryTags(categoryId: $categoryId) {
      category {
        id
        key
        name
        description
      }
    }
  }
`;
